import { type LoaderFunction, type Params, type RouteObject, redirect } from 'react-router-dom';

// Legacy pages now live inside the CMS page, which routes itself on `?view=`.
const viewRedirect =
  (view: string | ((params: Params) => string)): LoaderFunction =>
  ({ request, params }) => {
    const { searchParams } = new URL(request.url);
    searchParams.set('view', typeof view === 'string' ? view : view(params));
    return redirect(`/${params.lang}?${searchParams}`);
  };

export const legacyRoutes: RouteObject[] = [
  { path: 'zones', loader: viewRedirect('zones') },
  { path: 'zones/:slug', loader: viewRedirect(({ slug }) => `zones/${slug}`) },
  { path: 'zone/:slug', loader: viewRedirect(({ slug }) => `zones/${slug}`) },
  { path: 'events/:slug', loader: viewRedirect(({ slug }) => `events/${slug}`) },
  { path: 'explore', loader: viewRedirect('explore') },
  { path: 'booklets', loader: viewRedirect('booklets') },
  { path: 'terms', loader: viewRedirect('terms') },
  { path: 'privacy', loader: viewRedirect('privacy') },
  { path: 'contact-us', loader: viewRedirect('contact') },
  {
    path: '*',
    loader: ({ request, params }) => redirect(`/${params.lang}${new URL(request.url).search}`),
  },
];
